import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { useContext } from 'react'
import { useNavigate } from 'react-router'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Step1Form } from '../../../containers/carkulka-extra/Step1Form'
import { StepsContent } from '../../../context/StepsContext'
import { useUpdateLastWizardStep } from '../../../hooks/useWizard'
import { useSaveInsuranceParams } from '../../../hooks/useWizardAddon'
import { insuranceParamsContext } from '../../../layouts/Wizard'

export const Step1 = () => {
  const navigate = useNavigate()

  const { insuranceParams, insuranceParamsId: paramsId, refetchInsuranceParams, isLoadingData } = useContext(insuranceParamsContext)

  const { mutateAsync: updateStep } = useUpdateLastWizardStep()
  const { mutateAsync: saveInsuranceParams } = useSaveInsuranceParams()

  const handleSubmit = (values: InsuranceParamsDto) =>
    saveInsuranceParams(values)
      .then((response) => {
        if (paramsId)
          refetchInsuranceParams()

        if (values.nextPage == 'next') {
          if ((insuranceParams?.generalParams.lastWizardStep ?? 1) == 1)
            updateStep({ paramsId: Number(response?.data), step: 2, stepsStep: 'carkulka-extra' }).then(() => refetchInsuranceParams())
          navigate(`/carkulka/extra/wizard/2/${response?.data}`)
        } else {
          navigate(`/carkulka/extra/wizard/1/${response?.data}`)
        }

        return response
      })

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!paramsId || insuranceParams) &&
          <StepsContent step={1}>
            <Steps icon="car" />

            <Step1Form onSubmit={handleSubmit} data={insuranceParams as InsuranceParamsDto} />
          </StepsContent>
        }

        <WizardForbiddenMessage />

      </Container>
    </Section>
  )
}
